import { RootState } from '../store';

import { ICardTransactionState } from './card-transaction.slice';

export const selectCardTransaction = (state: RootState): ICardTransactionState =>
    state.cardTransaction;
